import { BookOpen } from 'lucide-react'

interface Props {
  variant?: 'default' | 'outline'
  className?: string
}

export default function GuideViewerButton({ variant = 'default', className = '' }: Props) {
  const base =
    'inline-flex items-center gap-2 rounded-lg px-5 py-2.5 text-sm font-semibold transition-all duration-150 cursor-pointer no-underline'

  const styles =
    variant === 'outline'
      ? `${base} bg-transparent border border-tq-green text-tq-green hover:bg-tq-green/10 ${className}`
      : `${base} bg-tq-green text-white hover:bg-tq-green-dark shadow-sm hover:shadow-md ${className}`

  return (
    <a
      href="/guide"
      className={styles}
      style={variant === 'default' ? { background: '#2d6614' } : undefined}
    >
      <BookOpen className="h-4 w-4 flex-shrink-0" />
      Lire le Guide Utilisateur
    </a>
  )
}
